import { render, staticRenderFns } from "./SimpleProductBlock.vue?vue&type=template&id=3508d9ad&scoped=true"
import script from "./SimpleProductBlock.vue?vue&type=script&lang=js"
export * from "./SimpleProductBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508d9ad",
  null
  
)

export default component.exports